export default {
  SET_USER(state, data) {
    state.user = data;
  },
  SET_LICENSES(state, data) {
    state.licenses = data;
  },
  RESET_STATE (state, data) {
    Object.assign(state, data)
  },
};
